"use client";

import React from "react";
import { EventTrackerProvider, MarketingApiClient } from "@audacia-hq/shared/components";
import { UserSession } from "@audacia-hq/shared/models";

import config from "../services/config";
import axios from "../services/axios";

interface Props {
  children: React.ReactNode
  userSession: UserSession
}
const marketingClient = new MarketingApiClient(config.apiBaseHost, "idealvoyance", "iv-website", axios);

const EventTrackerProviderWrapper: React.FC<Props> = ({ children, userSession }) => <EventTrackerProvider userSession={userSession} client={marketingClient}>{children}</EventTrackerProvider>;

export default EventTrackerProviderWrapper;
